import { useState, type ReactNode } from 'react';
import { BarChart3, List, PhoneMissed } from 'lucide-react';
import { PageHeading } from '../../components/ui/PageHeading';
import { CallHistory } from '../../telephony/components/CallHistory';
import {
  TelephonyWorkplacePanel,
  type WorkplaceDialTarget,
} from '../../telephony/components/TelephonyWorkplacePanel';
import './calls.css';
import { CallStatisticsPanel } from './CallStatisticsPanel';

export type CallsTab = 'JOURNAL' | 'WORKPLACE' | 'STATISTICS';

export type CallsPageProps = {
  onDial: (target: WorkplaceDialTarget) => void;
  initialTab?: CallsTab;
  statistics?: ReactNode;
};

const TABS: ReadonlyArray<{
  id: CallsTab;
  label: string;
  note: string;
  icon: typeof List;
}> = [
  { id: 'JOURNAL', label: 'Журнал', note: 'Все звонки и записи', icon: List },
  { id: 'WORKPLACE', label: 'Пропущенные и перезвоны', note: 'Очередь обработки', icon: PhoneMissed },
  { id: 'STATISTICS', label: 'Статистика', note: 'Показатели и динамика', icon: BarChart3 },
];

export function CallsPage({ onDial, initialTab = 'JOURNAL', statistics }: CallsPageProps) {
  const [activeTab, setActiveTab] = useState<CallsTab>(initialTab);

  return <main className="calls-page">
    <PageHeading
      eyebrow="ЗВОНКИ"
      title="Звонки"
      description="Журнал разговоров, пропущенные обращения и задачи на перезвон"
    />

    <nav className="calls-page__tabs surface" role="tablist" aria-label="Разделы звонков">
      {TABS.map(tab => {
        const Icon = tab.icon;
        const selected = activeTab === tab.id;
        return <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={selected}
          aria-controls={`calls-panel-${tab.id.toLowerCase()}`}
          className={selected ? 'active' : ''}
          onClick={() => setActiveTab(tab.id)}
        >
          <Icon aria-hidden="true" />
          <span><b>{tab.label}</b><small>{tab.note}</small></span>
        </button>;
      })}
    </nav>

    <section
      className="calls-page__content"
      id={`calls-panel-${activeTab.toLowerCase()}`}
      role="tabpanel"
    >
      {activeTab === 'JOURNAL' && <CallHistory />}
      {activeTab === 'WORKPLACE' && <TelephonyWorkplacePanel onDial={onDial} />}
      {activeTab === 'STATISTICS' && (statistics ?? <CallStatisticsPanel />)}
    </section>
  </main>;
}
